import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=bc0f02e8&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"
import style0 from "./claim.vue?vue&type=style&index=0&id=bc0f02e8&lang=scss&scoped=true&"
import style1 from "./claim.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f02e8",
  null
  
)

export default component.exports